import { Button, Form, Input } from "antd";
import React from "react";

const BasicFormItem = ({ props }) => {
  const { label, placeholder, isRequired, isType, title } = props;
  const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 12,
    },
  };
  return (

    <Form.Item
      {...formItemLayout}
      label={<p className="sc-form-label">{title}</p>}
      name={label}
      rules={[{
        required: isRequired,
      }]}
    >
      <Input
        className="sc-form-input boxBorder boxBorderRad"
        placeholder={placeholder}
        type={isType}
      />
    </Form.Item>

  );
};

export default BasicFormItem;
